// BARREL FILE FOR FOOTER COMPONENTS
export { SocialMedia } from './SocialMedia';
export { AppDownload } from './AppDownload';
